import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-black fw-semibold" }, "Liste des offres")
], -1)
const _hoisted_3 = { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }
const _hoisted_4 = { class: "d-sm-flex align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-plus-circle" }, null, -1)
const _hoisted_6 = { class: "d-flex align-items-center" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "bg-transparent text-primary transition p-0 border-0"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-search-interface-symbol" })
], -1)
const _hoisted_8 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_9 = { class: "table-responsive" }
const _hoisted_10 = { class: "table text-nowrap align-middle mb-0" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Catégorie "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Titre "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Description "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Salaire "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date Publication "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
    }, " Date Expiration "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text pe-0"
    }, "ACTIONS")
  ])
], -1)
const _hoisted_12 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_13 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_14 = {
  class: "shadow-none lh-1 fw-medium text-black-emphasis p-2",
  style: {"max-width":"300px","word-wrap":"break-word","white-space":"normal"}
}
const _hoisted_15 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_16 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_17 = { class: "shadow-none lh-1 fw-medium text-black-emphasis" }
const _hoisted_18 = { class: "shadow-none lh-1 fw-medium text-body-tertiary text pe-0" }
const _hoisted_19 = { class: "dropdown" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("span", {
  class: "badge text-white bg-primary fs-15 dropdown-toggle",
  "data-bs-toggle": "dropdown",
  "aria-expanded": "false"
}, [
  /*#__PURE__*/_createTextVNode(" Actions "),
  /*#__PURE__*/_createElementVNode("i", { class: "flaticon-chevron-2 position-relative ms-5 top-2 fs-15" })
], -1)
const _hoisted_21 = {
  class: "dropdown-menu dropdown-block",
  style: {"position":"absolute","inset":"0px auto auto 0px","margin":"0px","transform":"translate(267px, 305px)"},
  "data-popper-placement": "bottom-start"
}
const _hoisted_22 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-pen lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_24 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_26 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_28 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("i", { class: "flaticon-eye lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_30 = { class: "dropdown-item d-flex align-items-center" }
const _hoisted_31 = ["onClick"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "fa fa-trash-o lh-1 me-8 position-relative top-1" }, null, -1)
const _hoisted_33 = { class: "pagination-area d-md-flex mt-15 mt-sm-20 mt-md-25 justify-content-between align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_PaginationComponent = _resolveComponent("PaginationComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_router_link, {
          class: "btn btn-primary",
          to: "/ajouter-offre"
        }, {
          default: _withCtx(() => [
            _hoisted_5,
            _createTextVNode(" Ajouter une offre ")
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("form", {
          class: "search-box position-relative",
          onSubmit: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args)), ["prevent"]))
        }, [
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchTerm) = $event)),
            onKeyup: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.rechercher && _ctx.rechercher(...args))),
            class: "form-control shadow-none text-black rounded-0 border-0",
            placeholder: "Rechercher une offre"
          }, null, 544), [
            [_vModelText, _ctx.searchTerm]
          ]),
          _hoisted_7
        ], 32)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("table", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("tbody", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.offres, (offre, index) => {
              return (_openBlock(), _createElementBlock("tr", { key: index }, [
                _createElementVNode("td", _hoisted_12, _toDisplayString(offre?.categorieOffre?.libelle), 1),
                _createElementVNode("td", _hoisted_13, _toDisplayString(offre.titre), 1),
                _createElementVNode("td", _hoisted_14, _toDisplayString(offre.description), 1),
                _createElementVNode("td", _hoisted_15, _toDisplayString(_ctx.separateur(offre.salaire)), 1),
                _createElementVNode("td", _hoisted_16, _toDisplayString(_ctx.format_Date(offre.datePublication)), 1),
                _createElementVNode("td", _hoisted_17, _toDisplayString(_ctx.format_Date(offre.dateExpiration)), 1),
                _createElementVNode("td", _hoisted_18, [
                  _createElementVNode("div", _hoisted_19, [
                    _hoisted_20,
                    _createElementVNode("ul", _hoisted_21, [
                      _createElementVNode("li", _hoisted_22, [
                        _createVNode(_component_router_link, {
                          to: { name: 'EditOffrePage', params: { id: offre.id } },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_23,
                            _createTextVNode("Modifier")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_24, [
                        _createVNode(_component_router_link, {
                          to: { name: 'ViewOffrePage', params: { id: offre.id } },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_25,
                            _createTextVNode("Détails ")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_26, [
                        _createVNode(_component_router_link, {
                          to: { name: 'CandidatureOffrePage', params: { id: offre.id } },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_27,
                            _createTextVNode("Candidats ")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_28, [
                        _createVNode(_component_router_link, {
                          to: { name: 'AvisOffrePage', params: { id: offre.id } },
                          class: "dropdown-item d-flex align-items-center"
                        }, {
                          default: _withCtx(() => [
                            _hoisted_29,
                            _createTextVNode("Avis ")
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]),
                      _createElementVNode("li", _hoisted_30, [
                        _createElementVNode("a", {
                          class: "dropdown-item d-flex align-items-center",
                          href: "javascript:void(0);",
                          onClick: ($event: any) => (_ctx.suppression(offre.id,_ctx.offres,'offres',`l\'offre ${offre.id}`))
                        }, [
                          _hoisted_32,
                          _createTextVNode(" Supprimer ")
                        ], 8, _hoisted_31)
                      ])
                    ])
                  ])
                ])
              ]))
            }), 128))
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createVNode(_component_PaginationComponent, {
          page: _ctx.page,
          totalPages: _ctx.totalPages,
          totalElements: _ctx.totalElements,
          limit: _ctx.limit,
          onPaginate: _ctx.handlePaginate
        }, null, 8, ["page", "totalPages", "totalElements", "limit", "onPaginate"])
      ])
    ])
  ]))
}